import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Card, CardContent, FormControlLabel, Grid, Radio, RadioGroup} from "@mui/material";
import BeatLoaderRegular from "../../../loaders/BeatLoaderRegular";
import {getWMSContainers} from "../../../../api/wms/wmsContainers/wmsContainers";
import {WMSContext} from "../../../../views/wms/context/WMSContext";
import {WmsContainerType} from "../../../../utils/WMSContainerType";
import CustomButton from "../../../CustomButton";
import {FormattedMessage} from "react-intl";
import {grey300, sidebarColor} from "../../../../assets/jss/main";

ManualMassTransfert.propTypes = {
    toContainers: PropTypes.array.isRequired,
    handleSelectedContainer: PropTypes.func.isRequired,
    shipments: PropTypes.array,
};

function ManualMassTransfert({toContainers, handleSelectedContainer, shipments = [] }) {
    const {currentInventory, currentOrganization} = useContext(WMSContext);

    const [loading, setLoading] = useState(true)
    const [containers, setContainers] = useState()
    const [selectedContainer, setSelectedContainer] = useState()

    const handleChange = (event) => {
        setSelectedContainer(event.target.value)
    }

    useEffect(() => {
        if (selectedContainer) {
            return;
        }

        let params = '';

        for (const [index, toContainer] of toContainers.entries()) {
            params += `${0 < index ? '&': ''}type[]=${toContainer}`
        }

        // Having a WmsContainerType.TIPPER in toContainers means this component was rendered during the TriShipping workflow.
        const isTipperWorkflow = toContainers.some((container) => WmsContainerType.TIPPER === container) && 0 < shipments.length;

        if (!isTipperWorkflow) {
            params += `&type[]=${WmsContainerType.SHELF}`
        }

        getWMSContainers(currentInventory.id, params).then((response) => {
            let result = response

            if (isTipperWorkflow && currentOrganization.containerToShippingMethodMatch) {
                const shipmentShippingMethodIds = shipments.map((s) => s.shippingMethodId).filter(Boolean)
                result = response.filter((container) =>
                    !container.shippingMethods?.length ||
                    container.shippingMethods.some((sm) => shipmentShippingMethodIds.includes(sm.id))
                )
            }

            setContainers(result)
        }).finally(() => {
            setLoading(false)
        })
    }, [shipments]);

    if (loading && !selectedContainer) {
        return (
            <Grid item sx={{margin: "auto"}}>
                <BeatLoaderRegular loading={true} size={15}/>
            </Grid>
        )
    }

    return (
        <Grid
            container
            direction={"column"}
            justifyContent={"space-between"}
            flexWrap={'nowrap'}
            sx={{height: "100%", minHeight: '0'}}
            flex={1}
        >
            <Grid
                container
                direction={"column"}
                sx={{overflow: 'auto'}}
            >
                <RadioGroup
                    onChange={handleChange}
                    value={selectedContainer}
                >
                    {containers && containers.length > 0 && containers.map((container) => (
                        <Card>
                            <CardContent style={{padding: 0, backgroundColor: sidebarColor}}>
                                <FormControlLabel
                                    value={container.codebar}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row-reverse",
                                        justifyContent: "space-between",
                                        margin: 0,
                                        padding: "16px",
                                        ':hover': {
                                            backgroundColor: grey300,
                                        },
                                    }}
                                    control={<Radio/>}
                                    label={container.name}
                                />
                            </CardContent>
                        </Card>
                    ))}
                </RadioGroup>
            </Grid>

            <Grid item>
                <Card>
                    <CardContent sx={{backgroundColor: sidebarColor}}>
                        <CustomButton
                            fullWidth
                            disabled={!selectedContainer || loading}
                            loading={loading}
                            onClick={() => {
                                setLoading(true)
                                handleSelectedContainer(selectedContainer)
                            }}
                        >
                            <FormattedMessage id={"wms.massTransfer.manualChoiceDrawer.button"}/>
                        </CustomButton>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}

export default ManualMassTransfert;